/* global $, Modernizr */

import jump from 'jump.js';
import formSerialize from 'form-serialize';
import debounce from '../../helpers/debounce';
import { rewriteHistory, getData } from './utils';
import fetchFromAPI from './api';

const $filter = $('.js-filter');
const $filterForm = $('.js-filter-form');
const $filterResult = $('.js-filter-result');
const $filterResultsCount = $('.js-filter-result-count');
const $filtersApply = $('.js-apply-filters');
const $filtersRemove = $('.js-remove-filters');
const $filtersActive = $('.js-filter-active');
const $options = $('.js-filters-options');
const $pagination = $('.js-filter-pagination');
const $pageInput = $('.js-filter-page');

const $overlay = $('.js-page-overlay');

const dataType = 'json';

const DEBOUNCE_VAL = 300;

const filter = {
  initialize() {
    if (!$filter.length || !$filterForm.length || !$filterResult.length) {
      // throw new Error('One or more filter elements are missing');
      return;
    }

    this.filtersCombined = () => {
      this.runFilter();
      this.outputSelectedFilters();
    };

    this.outputSelectedFilters();

    const debouncedFilters = debounce(this.filtersCombined, DEBOUNCE_VAL);

    $('.js-filter-form').on('click', ({ target }) => {
      if (!$(target).parents('.collapse').length) {
        $('.collapse').removeClass('show');
        $('.filter__option-wrapper > .btn').attr('aria-expanded', false);
      }
    });

    $filtersActive.on('click', '.js-remove-filter', ({ currentTarget }) => {
      const $target = $(currentTarget);

      $filterForm.find(`#${$target.data('id')}`).prop('checked', false);

      this.filtersCombined();
    });

    $filtersApply.on('click', () => {
      this.hideExpandedElements();
      this.setPageNumber(1);
      this.filtersCombined();
      this.checkFilterGroups();
    });

    if (Modernizr.mq('(min-width: 767px)')) {
      $filterForm.add($options).on('change', 'input[type="checkbox"]', () => {
        this.setPageNumber(1);
        this.filtersCombined();
        this.checkFilterGroups();
      });
    }

    $filterForm.add($options).on('change', 'input[type="radio"], select', () => {
      this.setPageNumber(1);
      this.filtersCombined();
      this.checkFilterGroups();
    });

    $filterForm.add($options).on('keyup', 'input[type="text"], input[type="search"], textarea', () => {
      debouncedFilters();
      this.checkFilterGroups();
    });

    $pagination.on('click', 'a', (e) => {
      e.preventDefault();
      const $el = $(e.currentTarget);
      let page = $el.data('page');

      if (typeof page === 'undefined') {
        return true;
      }

      page = parseInt(page, 10);

      this.setPageNumber(page);
      this.filtersCombined();
      this.scrollToResult();

      return false;
    });

    $filtersRemove.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      $filterForm.find('input[type="checkbox"], input[type="radio"]')
        .prop('checked', false)
        .removeAttr('checked');

      this.filtersCombined();
    });

    this.checkDisabledGroups();
  },

  checkFilterGroups() {
    const $groups = $('.js-filter-bar-item');

    $groups.each((i, el) => {
      const $group = $(el);
      const $clearFilter = $group.find('.js-clear-filters');
      const inputs = $group.find('input, select, textarea');
      let groupHasValues = false;

      inputs.toArray().forEach((input) => {
        if (input.tagName === 'INPUT' && (input.getAttribute('type') === 'checkbox' || input.getAttribute('type') === 'radio')) {
          if (input.checked) {
            groupHasValues = true;
          }
        } else if (input.value !== '') {
          groupHasValues = true;
        }
      });

      $clearFilter.toggleClass('is-open', groupHasValues);
    });
  },

  closeDropdowns() {
    $filterForm.find('.js-filter-dropdown').removeClass('is-visible');
    $('.js-filter-toggle').removeClass('is-open');
  },

  getPageNumber() {
    return parseInt($pageInput.val(), 10);
  },

  getApiUrl() {
    return getData($filter, 'filter-api', '');
  },

  getApiMethod() {
    return getData($filter, 'filter-api-method', 'POST');
  },

  setPageNumber(num) {
    $pageInput.val(num);
  },

  scrollToResult() {
    setTimeout(() => {
      jump($filterResult[0], {
        offset: Modernizr.mq('(max-width: 991px)') ? -65 : -180,
        a11y: false,
        duration: 300,
      });
    }, 1000);
  },

  serializeElement(el) {
    const serialized = formSerialize(el, { hash: true });
    return serialized;
  },

  runFilter() {
    const filters = this.serializeElement($filterForm[0]);
    const options = this.serializeElement($options[0]);
    const data = Object.assign({}, filters, options);

    $overlay.addClass('is-visible');

    rewriteHistory(data);

    fetchFromAPI(this.getApiUrl(), this.getApiMethod(), data, dataType, (res) => {
      const $html = $(res);

      this.outputFilterResult($html.find('.js-filter-result').html());
      this.outputPagination($html.find('.js-filter-pagination').html());
      this.outputResultCount($html.find('.js-filter-result-count').html());

      $overlay.removeClass('is-visible');

      $(window).trigger('sliders:refresh');
    });
  },

  outputFilterResult(html) {
    $filterResult.html(html);
  },

  outputPagination(html) {
    $pagination.html(html);
  },

  outputResultCount(html) {
    $filterResultsCount.html(html);
  },

  getSelectedFilters() {
    return $('.js-filter-bar-item > input:checked');
  },

  outputSelectedFilters() {
    const items = this.getSelectedFilters();
    const buttons = items.toArray().map(item => this.renderActiveFilterButton(item)).join('');

    $filtersActive
      .empty()
      .append(buttons)
      .toggleClass('d-flex mt-1 mt-sm-2 mt-md-3', items.length > 0);
  },

  checkDisabledGroups() {
    $('.js-filter-bar-item').each((i, item) => {
      const $checkboxes = $(item).find('input[type="checkbox"]:not(:disabled)');

      $(item).find('.js-filter-toggle').prop('disabled', (!$checkboxes.length));
    });
  },

  hideExpandedElements() {
    const elements = $filter.find('.collapse.show');

    if (!elements) {
      return true;
    }

    elements.collapse('hide');

    return false;
  },

  renderActiveFilterButton(item) {
    const $item = $(item);

    return `
      <button
        type="button"
        class="btn btn--filter btn--filter-active btn--sm js-remove-filter mr-1"
        data-id="${$item.attr('id')}"
      >
        ${this.getIcon('close')} ${$item.data('title')}
      </button>
    `;
  },

  getIcon(name) {
    return `
      <svg class="icon icon-${name}" aria-hidden="true">
        <use xlink:href="#icon-${name}"></use>
      </svg>
    `;
  },

  removeFilter() {

  },
};

export default filter;
